import moment from "moment";
export const DAILY_HOUR_LIMIT = 8;

export const WEEKENDS = [0, 6];

export const TAGS = [
  { id: "frontend", label: "Frontend Dev", color: "#60A5FA" },
  { id: "backend", label: "Backend Dev", color: "#818CF8" },
  { id: "testing", label: "Testing", color: "#A78BFA" },
  { id: "meeting", label: "Meeting", color: "#FBBF24" },
  { id: "docs", label: "Documentation", color: "#34D399" },
  { id: "bug", label: "Bug Fixing", color: "#F87171" },
  { id: "review", label: "Code Review", color: "#2DD4BF" },
  { id: "poc", label: "POC", color: "#FB7185" },
  { id: "other", label: "Other", color: "#94A3B8" },
];

export const HOLIDAYS_BY_YEAR = {
  2025: [
    { date: "2025-01-26", name: "Republic Day" },
    { date: "2025-02-20", name: "Guru Ravidas Jayanti" },
    { date: "2025-03-14", name: "Holi" },
    { date: "2025-04-18", name: "Good Friday" },
    { date: "2025-04-21", name: "Eid al-Fitr" },
    { date: "2025-05-23", name: "Buddha Purnima" },
    { date: "2025-06-05", name: "Bakrid (Eid al-Adha)" },
    { date: "2025-07-07", name: "Muharram" },
    { date: "2025-08-15", name: "Independence Day" },
    { date: "2025-08-27", name: "Janmashtami" },
    { date: "2025-09-16", name: "Eid-e-Milad" },
    { date: "2025-10-02", name: "Gandhi Jayanti" },
    { date: "2025-10-20", name: "Deepavali" },
    { date: "2025-11-15", name: "Guru Nanak Jayanti" },
    { date: "2025-12-25", name: "Christmas" },
  ],

  2026: [
    { date: "2026-01-26", name: "Republic Day" },
    { date: "2026-03-01", name: "Maha Shivratri" },
    { date: "2026-03-03", name: "Holi" },
    { date: "2026-03-20", name: "Eid al-Fitr" },
    { date: "2026-04-09", name: "Ram Navami" },
    { date: "2026-04-14", name: "Mahavir Jayanti" },
    { date: "2026-05-12", name: "Buddha Purnima" },
    { date: "2026-05-31", name: "Bakrid (Eid al-Adha)" },
    { date: "2026-07-26", name: "Muharram" },
    { date: "2026-08-15", name: "Independence Day" },
    { date: "2026-09-04", name: "Janmashtami" },
    { date: "2026-09-26", name: "Eid-e-Milad" },
    { date: "2026-10-02", name: "Gandhi Jayanti" },
    { date: "2026-10-20", name: "Dussehra" },
    { date: "2026-11-08", name: "Diwali" },
    { date: "2026-11-09", name: "Govardhan Puja" },
    { date: "2026-11-24", name: "Guru Nanak Jayanti" },
    { date: "2026-12-25", name: "Christmas" },
  ],
};

export const DAYS_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export function generateTimelogData() {
  const now = moment();
  const year = now.year();
  const month = now.month();

  const timelogs = [];

  // All holidays for this year (array of objects: { date, name })
  const holidaysForYear = (HOLIDAYS_BY_YEAR[year] || []).map((h) => h.date);

  let date = moment({ year, month, date: 1 });

  while (date.month() === month) {
    const dayOfWeek = date.day();
    const dateStr = date.format("YYYY-MM-DD");

    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
    const isHoliday = holidaysForYear.includes(dateStr);

    // Skip weekends & holidays
    if (!isWeekend && !isHoliday) {
      // Random logs (1–3 tasks)
      const logsCount = Math.floor(Math.random() * 3) + 1;

      for (let i = 0; i < logsCount; i++) {
        const tag = TAGS[Math.floor(Math.random() * TAGS.length)];

        // Allowed hour durations
        const possibleHours = [1, 1.5, 2, 2.5, 3];
        const duration =
          possibleHours[Math.floor(Math.random() * possibleHours.length)];

        timelogs.push({
          id: `auto-${Date.now()}-${Math.random()}`,
          date: dateStr,
          title: `Demo task for ${tag.label}`,
          duration: Number(duration.toFixed(1)), // ensure 1 decimal
          tag: tag.id,
          notes: "",
          type: "timelog",
          createdAt: moment().toISOString(),
        });
      }
    }

    date.add(1, "day");
  }

  return timelogs;
}
